<img class="rounded-circle" alt="User Avatar" [src]="src" [ngStyle]="{ 'width': size, 'height': size }" loading="lazy" (error)="setDefault($event)">
